module.exports = __webpack_public_path__ + "static/img/Sport_Nutrition_Circle.2d5e621b.png";